import { render, staticRenderFns } from "./ModalContractDocument.vue?vue&type=template&id=350c5726&"
import script from "./ModalContractDocument.vue?vue&type=script&lang=js&"
export * from "./ModalContractDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports